import _slicedToArray from "/Users/harsha919/Desktop/ONESAZ/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack, DEG2RAD } from '../../utils/index.js';
var sin = Math.sin,
  cos = Math.cos;
var lch2lab = function lch2lab() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  /*
  Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
  These formulas were invented by David Dalrymple to obtain maximum contrast without going
  out of gamut if the parameters are in the range 0-1.
   A saturation multiplier was added by Gregor Aisch
  */
  var _unpack = unpack(args, 'lch'),
    _unpack2 = _slicedToArray(_unpack, 3),
    l = _unpack2[0],
    c = _unpack2[1],
    h = _unpack2[2];
  if (isNaN(h)) h = 0;
  h = h * DEG2RAD;
  return [l, cos(h) * c, sin(h) * c];
};
export default lch2lab;